/*
 * View for the context selector for topics
 */

define([
  "marionette",
  "modules/topicsSplit/topic/topicContext/template/topicContextTemplate.html",
  "modules/topicsSplit/topic/topicContext/template/topicContextItemTemplate.html",
], function (Marionette, TopicContextTemplate, TopicContextItemTemplate) {
  var TopicContextView = {};

  TopicContextView.topicContextView = Marionette.ItemView.extend({
    template: TopicContextItemTemplate,
    tagName: "li",
    triggers: {
      click: "select:context",
    },
  });

  TopicContextView.topicContextsView = Marionette.CompositeView.extend({
    template: TopicContextTemplate,
    itemView: TopicContextView.topicContextView,
    itemViewContainer: "ul",
    modelEvents: {
      sync: "render",
      change: "render",
    },
  });

  return TopicContextView;
});
